import { Factura } from '@/types/invoices/factura';
import { FacturaActions, facturaTypes } from '../types/facturaTypes';

interface FacturaReducer {
  facturas: Factura[];
  loading: boolean;
}
const initialState: FacturaReducer = {
  facturas: [],
  loading: false,
};

export const facturaReducer = (state = initialState, action: FacturaActions) => {
  switch (action.type) {
    case facturaTypes.startLoadingFacturas:
      return { ...state, loading: true };
    case facturaTypes.finishLoadingFacturas:
      return { ...state, loading: false };
    case facturaTypes.facturasLoad:
      return { ...state, facturas: action.payload };
    default:
      return state;
  }
};
